import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';

import './virtualstart_styles/createaccount.css';

export default function StartCreateAccount() {
  return (
    <>
      <Container className='mt-5 mb-5 start_createaccount'>
        <Row>
          <Col>
            <div className="account_head d-flex flex-column justify-content-center align-items-center">
              <h2>Win up to $100 in Welcome Rewards</h2>
              <span>Complete Beginner Tasks & Win Awesome Prize</span>
            </div>
            <div className='d-flex justify-content-center mt-4 start_createaccount_btn'>
              <Button className='w-50'>Create Account</Button>
            </div>
          </Col>
        </Row>  
      </Container>  
    </>
  )
}